import Swiper from "swiper11";
import { Autoplay, EffectFade, Navigation, Pagination, Thumbs } from "swiper11/modules";
import { lazyLoad, ImportBundle, createdThumbs, debounce } from "./utils";
import { initSearch, globalSearch } from "../common";
import { fixedsHeader, initToTop } from "./common";
import { countUp } from "@common/utils/additionalUtils";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import dialogFormInit from "./components/dialogForm-1";
$(function () {
  if (window.innerWidth === 1350 || window.innerWidth === 412) {
    $(document).one("mousemove", () => {
      initFunction();
    });
    $(document).one("scroll", () => {
      initFunction();
    });
  } else {
    initFunction();
  }
});
gsap.registerPlugin(ScrollTrigger, SplitText);
/*! Event End */
let initFunction = () => {
  
  ImportBundle({ type: "css", onlyIndex: true }, [
    "https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css",
    "https://static.yigetechcms.com/public/css/fancybox@5.0.0.min.css",
    "https://static.yigetechcms.com/public/css/bootstrap@4.6.2.min.css"
  ]);
  ImportBundle({ type: "js", onlyIndex: true }, [
    {
      src: "https://static.yigetechcms.com/public/js/bootstrap@4.6.2.min.js",
    },
    {
      src: "https://static.yigetechcms.com/public/js/jquery.SuperSlide.2.1.3.js",
      fn() {
        //@ts-ignore
        jQuery("._index_ .index-service .service-box").slide({
          titCell: ".left .list li",
          mainCell: ".right",
          effect: 'fold',
          titOnClassName: 'active'

        });
        //@ts-ignore
        jQuery("._index_ .index-service .service-box").slide({
          titCell: ".left .list li .content-box",
          targetCell: ".left .list li .des",
          effect: "slideDown",
        });
      },
    }
  ]);
  globalSearch();
  countUp('.counter');
  lazyLoad();
  initSearch();
  initSwiper();
  initEvent();
  dialogFormInit();
  initFunction = () => { };
};
function initEvent() {
  fixedsHeader("page__header");
  $('.header-language').on('click', function (e) {
    $(this).find('.list').slideToggle()
    e.stopPropagation()
  })
  $('body').on('click', function () {
    $('.header-language .list').slideUp()
  })
  initToTop('.scrollTop');
}
function initSwiper() {
  new Swiper("._index_ .index-banner .swiper-box .swiper", {
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    speed: 1200,
    pagination: {
      el: ".index-banner .swiper-box .swiper-pagination",
      clickable: true,
    },
    on: {
      init: function (swiper) {
        $(swiper.slides).eq(swiper.activeIndex).addClass('active');
      },
      slideChangeTransitionEnd: function (swiper) {
        $(swiper.slides).removeClass('active');
        $(swiper.slides).eq(swiper.activeIndex).addClass('active');
      }
    },
    autoplay: {
      disableOnInteraction: false,
      delay: 5e3,
    },
  });

  new Swiper("._index_ .index-news .swiper-text .swiper", {
    modules: [Autoplay, Thumbs, Pagination],
    slidesPerView: 1,
    spaceBetween: 15,
    speed: 1200,
    loop: true,
    autoplay: {
      disableOnInteraction: false,
    },
    pagination: {
      el: ".index-news .swiper-text .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1025: {
        slidesPerView: 2.2,
        spaceBetween: 32,
      },
    },
    on: {
      beforeInit: (swiper) => {
        createdThumbs(swiper, "._index_ .index-news .swiper-img .swiper", {
          swiperOptions: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        });
      },
    }
  });
}
